<router-outlet></router-outlet>
<!-- <div class="text-center" *ngIf="isLoading">
    <img src="assets/images/pre_lodding.gif" alt="loading">
</div> -->
<!-- <div class="text-center" id="loading" *ngIf="isLoading">
    <img src="assets/images/pre_lodding.gif" width="300" height="300">
</div> -->
